import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import AboutUs from "../components/AboutUs";
import Mission from "../components/Mission";
import Vision from "../components/Vision";
// import Services from "../components/Services";
import Testimonials from "../components/Testimonials";
import ContactUs from "../components/ContactUs";
import "../styles/App.css";

// Import images
import schoolImg1 from "../images/school_img_1.jpg";
import schoolImg2 from "../images/school_img_2.jpg";
import schoolImg3 from "../images/school_img_3.jpg";

// Import AdButton component
// import AdButton from "../components/AdButton";

const HomePage = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />

      {/* Hero Section with Carousel */}
      <section className="relative h-[80vh] w-full overflow-hidden">
        {/* Carousel Background */}
        <Carousel
          autoPlay
          infiniteLoop
          showArrows={false}
          showThumbs={false}
          showStatus={false}
          className="h-full w-full"
        >
          {[schoolImg1, schoolImg2, schoolImg3].map((image, index) => (
            <div key={index} className="h-[80vh] w-full">
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="object-cover h-full w-full"
              />
            </div>
          ))}
        </Carousel>

        {/* Overlay and Content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center  text-white text-center px-4 sm:px-10 z-10">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold mb-4 text-white">
            Welcome to{" "}
            <span className="text-blue-400">Radiant Model Academy</span>
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl mb-6">
            Empowering Students for a Bright Future
          </p>
          <div className="flex space-x-4">
            {/* Get Started Button */}
            <button className="group relative w-full sm:w-auto px-6 py-3 min-w-[160px] bg-gradient-to-r from-violet-600 to-cyan-600 rounded-lg">
              <div className="absolute inset-0 rounded-lg lg:blur-md blur-0 group-hover:opacity-60 transition-opacity duration-500"></div>
              <div className="relative flex items-center justify-center gap-2">
                <span className="text-white font-medium">Get Started</span>
                <svg
                  className="w-5 h-5 text-white transform group-hover:translate-x-1 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </div>
            </button>

            {/* Documentation Button */}
            {/* <button className="w-full sm:w-auto px-6 py-3 rounded-lg border border-white/10 bg-white/5 backdrop-blur-lg text-white/70 hover:bg-white/10 hover:text-white transition-all min-w-[160px]">
              Documentation
            </button> */}
          </div>
        </div>

        {/* Bottom SVG */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg
            viewBox="0 0 1440 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z"
              fill="white"
            />
          </svg>
        </div>
      </section>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-12 bg-white">
        <section className="my-12 bg-white shadow-md rounded-lg p-6">
          <h2 className="text-2xl font-bold text-center mb-4 text-green-700">
            <span className="text-blue-500">Radiant Model Academy</span> - The
            Hope Of Africa!
          </h2>
          <p className="text-lg leading-relaxed text-gray-700 mb-4">
            "Africa can stem the flow of brain drain by investing in top-tier
            education and research systems that empower talent to thrive
            locally."
          </p>
          <AboutUs />
        </section>

        {/* Mission & Vision Sections */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 my-16 px-4 md:px-0">
          {/* Mission */}
          <section className="bg-gradient-to-br from-green-50 to-white shadow-lg rounded-2xl p-8 border-l-8 border-green-600 transition-transform transform hover:scale-105 duration-300">
            <div className="flex items-center gap-4 mb-4">
              <div className="text-green-700 text-3xl">
                <i className="fas fa-bullseye"></i>
              </div>
              <h2 className="text-2xl font-bold text-green-800">Our Mission</h2>
            </div>
            <Mission />
          </section>

          {/* Vision */}
          <section className="bg-gradient-to-br from-green-50 to-white shadow-lg rounded-2xl p-8 border-l-8 border-green-600 transition-transform transform hover:scale-105 duration-300">
            <div className="flex items-center gap-4 mb-4">
              <div className="text-green-700 text-3xl">
                <i className="fas fa-eye"></i>
              </div>
              <h2 className="text-2xl font-bold text-green-800">Our Vision</h2>
            </div>
            <Vision />
          </section>
        </div>

        {/* Services Section */}
        {/* <section className="my-12 bg-white shadow-md rounded-lg p-6 border-t-4 border-blue-500">
          <Services />
        </section> */}

        {/* Testimonials Section */}
        <section className="my-12 bg-white shadow-md rounded-lg p-6 border-t-4 border-green-700">
          <Testimonials />
        </section>

        {/* Contact Us Section */}
        <section className="my-12 bg-white shadow-md rounded-lg p-6 border-t-4 border-blue-500">
          <h2 className="text-4xl font-bold text-center mb-6 text-green-700">
            Get in Touch
          </h2>
          <ContactUs />
        </section>
      </main>

      {/* Apply Now Button */}
      <div className="flex justify-center my-8">{/* <AdButton /> */}</div>

      <Footer />
    </div>
  );
};

export default HomePage;
